var _mask, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_466_28568",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    rx: 1,
    fill: "#404D6A",
    stroke: "#404D6A",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_466_28568)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7076 11.2923C21.8005 11.3852 21.8743 11.4955 21.9246 11.6169C21.975 11.7383 22.0009 11.8684 22.0009 11.9998C22.0009 12.1312 21.975 12.2614 21.9246 12.3828C21.8743 12.5041 21.8005 12.6144 21.7076 12.7073L14.7076 19.7073C14.6147 19.8003 14.5044 19.874 14.383 19.9244C14.2616 19.9747 14.1315 20.0006 14.0001 20.0006C13.8687 20.0006 13.7385 19.9747 13.6171 19.9244C13.4957 19.874 13.3854 19.8003 13.2926 19.7073L10.2926 16.7073C10.1049 16.5197 9.99951 16.2652 9.99951 15.9998C9.99951 15.7344 10.1049 15.48 10.2926 15.2923C10.4802 15.1047 10.7347 14.9993 11.0001 14.9993C11.2654 14.9993 11.5199 15.1047 11.7076 15.2923L14.0001 17.5861L20.2926 11.2923C20.3854 11.1993 20.4957 11.1256 20.6171 11.0753C20.7385 11.0249 20.8687 10.999 21.0001 10.999C21.1315 10.999 21.2616 11.0249 21.383 11.0753C21.5044 11.1256 21.6147 11.1993 21.7076 11.2923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSelect);
export default __webpack_public_path__ + "static/media/active-select.b69b108c0fa739ec9ad8da5ad699499d.svg";
export { ForwardRef as ReactComponent };